import { Box, Row } from "@tokenterminal/ui/Box"
import { Link, type LinkProps } from "@tokenterminal/ui/Link"
import { TagLabel } from "@tokenterminal/ui/TagLabel"
import { ProjectLogo } from "components/terminal/ProjectInfo/ProjectLogo"
import { type ForwardedRef, type ReactNode, forwardRef, memo } from "react"
import {
  searchRowIcon,
  searchRow,
  searchResultWrapper,
  searchResultRow,
} from "./SearchResults.css"
import type { ProjectType } from "types/ApiTypes"

type SearchResultItem = Partial<Pick<ProjectType, "is_new" | "logo">> &
  Pick<ProjectType, "name"> & { symbol?: string | null }

interface Props extends Omit<LinkProps, "className" | "onClick" | "children"> {
  item: SearchResultItem
  onClick?: () => void
  children?: ReactNode
  icon?: ReactNode | JSX.Element // Provide either logo (project) or icon (anything you want, just make sure it's the right size)
}

export type { Props as SearchResultProps }

const SearchResultName = ({
  name,
  symbol,
  logo,
  is_new,
  icon,
}: SearchResultItem & Pick<Props, "icon">) => {
  return (
    <Row start className={searchRow}>
      <Box className={searchRowIcon}>
        {logo && <ProjectLogo logo={logo} name={name} size="16" />}
        {icon}
      </Box>
      <div className="text-fg-default text-base font-medium">
        {name}
        {symbol && <span className="opacity-50">{` (${symbol})`}</span>}
      </div>
      {is_new && <TagLabel />}
    </Row>
  )
}

const SearchResult = (
  { item, children, icon, ...linkProps }: Props,
  ref: ForwardedRef<HTMLAnchorElement>
) => {
  return (
    <Link
      {...linkProps}
      ref={ref}
      display="grid"
      width="100%"
      // paddingRight="xs"
      className={[
        searchResultWrapper,
        {
          [searchResultRow]: !children,
        },
      ]}
    >
      <SearchResultName {...item} icon={icon} />
      {children}
    </Link>
  )
}

export default memo(forwardRef(SearchResult))
